// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__oVisv","breadcrumbs__list":"Breadcrumbs_breadcrumbs__list__x3ICt","breadcrumbs__arrow":"Breadcrumbs_breadcrumbs__arrow__uHaZ_"};